<template>
    <div class="d-flex mb-4" :class="floatSelect">
        <div class="card ai-message w-75" :class="classSelect()">
            <div class="card-header d-flex justify-content-between p-3">
                <p class="fw-bold mb-0"><strong>{{this.name}}</strong></p>
                <p class="text-muted small mb-0"><i class="fa fa-clock"></i> {{this.timestamp}}</p>
            </div>
            <div class="card-body">
                <span v-if="this.iselps"><div class="elip_loading"></div><!-- div class="fas fa-ellipsis-h"></div --></span>
                <p class="mb-0" v-html="replaceWithBr(message)" />
                <div v-if="this.affinity">
                    <hr>
                    <div class="container-fluid mt-1">
                        <div class="row">
                            <div class="col">
                                <p class="text-warning mr-2" style="max-width: 200px;"><em>Analyze 360 can help you find new customers related to this audience.</em></p>
                            </div>
                            <div class="col">
                                <button class="btn btn-lg btn-info mt-3" @click="processAffinityClick()" v-if="loading_affin"><i class="fa fas fa-megaphone"></i> Explore Audiences</button>
                                <div class="loader-container" v-else>
                                    <div class="loader">
                                        <i class="fas fa-spinner fa-pulse fa-10x"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'AIMessage',
    props: {
        message: '',
        name: 'AI Assistant',
        timestamp: '',
        floatSelect: '',
        iselps: false,
        affinity: false
    },
    data() {
        return {
            loading_affin: true
        }
    },
     methods: {   
        classSelect() {
            if(this.floatSelect === 'flex-row') {
                return 'text-white bg-dark';
            } else {
                return 'text-dark bg-light';
            }
            
        },
        replaceWithBr(dat) {
            return dat.replace(/\n/g, "<br />")
        },
        processAffinityClick() {
            console.log('DELETE BUTTON OR ETC');
            this.loading_affin = false;
            this.$emit('generateAffinity', {answer: this.message});
        } 
    },
    mounted() {
    }
}

</script>